// @ts-check

/**
 * Open mobile menu on .burgerBun click.
 */
jQuery( '.burgerBun' ).on( 'click', function() {
    jQuery( '.burgerBun' ).toggleClass( "open" );
    jQuery( '.menu-mobile-menu-container' ).toggleClass( "open" );
} );

jQuery( '.menu-mobile-menu-container a' ).on( 'click', function() {
    jQuery( '.burgerBun' ).removeClass( "open" );
    jQuery( '.menu-mobile-menu-container' ).removeClass( "open" );
} );


/*
Using intersection observer is way more efficient than adding a scroll listener for this task
*/
const header = document.getElementById( 'site-header' );
const scrollIndicator = document.getElementById( 'site-header-scroll-indicator' );
if ( header && scrollIndicator ) {
    const scrollDeterminer = new IntersectionObserver( headerScrollHandler, {} );
    scrollDeterminer.observe( scrollIndicator );
    /**
     * @param {IntersectionObserverEntry[]} entries
     *
     * @return void
     */
    function headerScrollHandler( entries ) {
        entries.forEach( entry => {
            header?.classList.toggle( 'scroll', !entry.isIntersecting );
        } );
    }
}

jQuery( '.nav-menu' ).on( 'click', function() {
    if ( window.innerWidth > 1200 ) {
        jQuery( '#sideMenu' ).animate( {
            width: '40%',
            padding: '100px 70px',
        }, 300 );
    } else if ( window.innerWidth > 992 ) {
        jQuery( '#sideMenu' ).animate( {
            width: '400px',
            padding: '40px',
        }, 300 );
    } else {
        jQuery( '#sideMenu' ).animate( {
            width: '100%',
            maxWidth: '100%',
            padding: '50px',
        }, 300 );
    }

    jQuery( '#sideMenuOverlay' ).fadeIn( 500 );
    jQuery( '#sideMenu .side-menu-title' ).fadeIn( 600 );
    jQuery( '#sideMenu .side-menu-menu' ).fadeIn( 900 );
    jQuery( '#sideMenu #closeBanner' ).fadeIn( 500 );
} );

jQuery( '#closeBanner' ).on( 'click', function() {
    jQuery( '#closeBanner' ).hide();

    jQuery( '#sideMenu .side-menu-title' ).fadeOut( 100 );
    jQuery( '#sideMenu .side-menu-menu' ).fadeOut( 100 );
    jQuery( '#sideMenu #closeBanner' ).fadeOut( 100 );
    jQuery( '#sideMenuOverlay' ).fadeOut( 100 );

    jQuery( '#sideMenu' ).animate( {
        width: '0%',
        padding: '0',
    }, 500 );
} );

jQuery('#sideMenuOverlay').on('click', function() {
    jQuery('#closeBanner').click();
});

jQuery('#sideMenu .button.ghost').on('click', function() {
    jQuery('#closeBanner').click();
});

headerMargin();
window.addEventListener( 'load', headerMargin, { passive: true } );
window.addEventListener( 'resize', headerMargin, { passive: true } );

function headerMargin() {
    let position = jQuery( '#site-header' ).css( 'position' );
    if ( position == 'fixed' ) {
        setTimeout( function() {
            if ( window.innerWidth < 768 ) {
                var headerHeight = jQuery( '#site-header' ).outerHeight();
                jQuery( 'body' ).css( 'margin-top', headerHeight + 'px' );
            } else {
                jQuery( 'body' ).css( 'margin-top', '0px' );
            }
        }, 400 );
    }
}
